export const dashboardRoutes = {
    label: 'Dashboard',
    labelDisable: true,
    children: [
        {
            name: 'Dashboard',
            active: true,
            icon: 'chart-pie',
            children: [
                {
                    name: 'Sales Indicators',
                    to: '/',
                    exact: true,
                    active: true
                },
                {
                    name: 'Akasia POS',
                    to: '/dashboard/akasia-pos',
                    active: true
                },
                {
                    name: 'Support Desk',
                    to: '/dashboard/support-desk',
                    active: true
                }
            ]
        }
    ]
};

var contabilidad = null;


contabilidad = {
    name: 'Contabilidad',
    icon: 'book',
    active: true,
    children: [
        {
            name: 'Conciliaci\u00F3n',
            active: true,
            children: [
                {
                    name: 'Pagos',
                    to: '/contabilidad/conciliacion/pagos',
                    active: true
                },
                {
                    name: 'Conciliar',
                    to: '/contabilidad/conciliacion/conciliacion-bancos',
                    active: true
                },
                {
                    name: 'Cuentas',
                    to: '/Contabilidad/conciliacion/cuentas',
                    active: true
                }

            ]
        },
        {
            name: 'Facturaci\u00F3n',
            active: true,
            children: [
                {
                    name: 'Ajustes',
                    to: '/contabilidad/facturacion/ajustes',
                    active: true
                },
                {
                    name: 'Cargar XML',
                    to: '/contabilidad/facturacion/cargar-xml',
                    active: true
                },
                {
                    name: 'Fact. Recibidas',
                    to: '/contabilidad/facturacion/facturas-recibidas',
                    active: true
                },
                {
                    name: 'Fact. Emitidas',
                    to: '/contabilidad/facturacion/facturas-emitidas',
                    active: true
                },/*
                {
                    name: 'R. E. Pagos',
                    to: '/contabilidad/complemento-pagos',
                    active: true
                },*/
                {
                    name: 'Pagos Emitidos (R. E.)',
                    to: '/contabilidad/facturacion/pagos-emitidos',
                    active: true
                },
                {
                    name: 'Pagos recibidos (R.E.)',
                    to: '/contabilidad/facturacion/pagos-recibidos',
                    active: true
                },/*
                {
                    name: 'Notas de cr\u00E9dito',
                    to: '/contabilidad/nota-credito',
                    active: true
                },
                {
                    name: 'Anticipos',
                    to: '/contabilidad/anticipos',
                    active: true
                },*/
                {
                    name: 'N\u00F3mina',
                    to: '/contabilidad/facturacion/nomina',
                    active: true
                },
                {
                    name: 'Nueva Factura',
                    to: '/contabilidad/facturacion/formulario-factura',
                    active: true
                },


            ]
        }, {
            name: 'Activo Fijo',
            to: '/contabilidad/activofijo',
            active: true
        },
        {
            name: 'Empleados',
            to: '/contabilidad/empleados',
            active: true,
            children: [
                {
                    name: 'Lista de empleados',
                    to: '/contabilidad/empleados/lista',
                    active: true
                },
                {
                    name: 'Vacaciones',
                    to: '/contabilidad/empleados/vacaciones',
                    active: true
                }
            ]
        },
        //{
        //    name: 'Productos',
        //    to: '/contabilidad/productos',
        //    active: true
        //},
        {
            name: 'Gastos / Egresos',
            to: '/contabilidad/gastos',
            active: true
        },
        {
            name: 'Impuestos',
            to: '/contabilidad/impuestos',
            active: true
        },
        /*
                {
                    name: 'N\u00F3mina',
                    to: '/clientes/nuevo',
                    active: true,
                    children: [
                        {
                            name: 'Ordinaria',
                            to: '/contabilidad/conciliacion',
                            active: true
                        },
                        {
                            name: 'Extraordinaria',
                            to: '/contabilidad/conciliacion',
                            active: true
                        },
                        {
                            name: 'Recibos',
                            to: '/contabilidad/conciliacion',
                            active: true
                        },
                        {
                            name: 'Empleados',
                            to: '/contabilidad/conciliacion',
                            active: true
                        },
                        {
                            name: 'Ajustes',
                            to: '/contabilidad/conciliacion',
                            active: true
                        }
                    ]
                },
                {
                    name: 'Impuestos',
                    to: '/ordenes/',
                    active: true
                }*/
    ]
};

export var appRoutes = {
    label: 'app',
    children: [
        /* {
           name: 'Calendario',
           icon: 'calendar-alt',
           to: '/calendario',
           active: true
         },*/
        {
            name: 'Reportes',
            icon: 'book',
            active: true,
            children: [
                {
                    name: 'Reporte Ventas',
                    active: true,
                    to: 'administradores/reporte-ventas'
                },
                {
                    name: 'Reporte Seguimiento',
                    active: true,
                    to: 'administradores/reporte-seguimiento-leads'

                }
            ]
        },
        {
            name: 'Leads',
            icon: 'user',
            active: true,
            to: '/contactos'
        },
        {
            name: 'Marketing',
            icon: 'chart-line',
            active: true,
            children: [

                {
                    name: 'Dashboard',
                    to: '/marketing/dashboard',
                    active: true
                },
                {
                    name: 'Calendario editorial',
                    to: '/marketing/calendario-editorial',
                    active: true
                }
            ]
        },
        contabilidad,
        {
            name: 'Clientes',
            icon: 'shopping-cart',
            active: true,
            children: [
                {
                    name: 'Cat\u00E1logo clientes',
                    to: '/clientes',
                    active: true
                },
                {
                    name: 'Nuevo cliente',
                    to: '/clientes/nuevo',
                    active: true
                },
                {
                    name: 'Lista de \u00F3rdenes',
                    to: '/ordenes',
                    active: true
                },
                {
                    name: 'Distribuidores',
                    to: '/distribuidores',
                    active: true
                }
            ]
        },
        {
            name: 'Productos',
            icon: 'archive',
            active: true,
            children: [
                {
                    name: 'Cat\u00E1logo Productos',
                    to: '/productos/catalogo',
                    active: true
                },
                {
                    name: 'Nuevo Producto',
                    to: '/productos/nuevo',
                    active: true
                },
            ]
        },
        {
            name: 'Licencias',
            icon: 'file',
            active: true,
            children: [
                {
                    name: 'Cat\u00E1logo licencias',
                    to: '/licencias/',
                    active: true
                },
                {
                    name: 'Nueva Licencia',
                    to: '/licencias/nueva',
                    active: true
                },
                {
                    name: 'Usuarios Nube Akasia',
                    to: '/servicios/usuarios-nube-akasia',
                    active: true
                }
                ,
                {
                    name: 'Logs',
                    to: '/logservicios/logs',
                    active: true
                }
            ]
        },
        //{
        //    name: 'Soporte',
        //    icon: 'ticket-alt',
        //    active: true,
        //    children: [

        //        {
        //            name: 'Tickets',
        //            to: '/soporte-tecnico',
        //            active: true
        //        }
        /*  {
              name: 'Detalle contacto',
              to: '/support-desk/contact-details',
              active: true
          },
          {
              name: 'Previsualiza ticket',
              to: '/support-desk/tickets-preview',
              active: true
          },
          {
              name: 'Links',
              to: '/support-desk/quick-links',
              active: true
          },
          {
              name: 'Reportes',
              to: '/support-desk/reports',
              active: true
          }*/
        //    ]
        //},
        {
            name: 'M\u00f3dulos',
            icon: 'ticket-alt',
            active: true,
            children: [
                {
                    name: 'POS Fact. Guatemala',
                    to: '/servicios/facturacion-guatemala',
                    active: true
                }
                ,
                {
                    name: 'POS Fact. Ecuador',
                    to: '/servicios/facturacion-ecuador',
                    active: true
                }
                ,
                {
                    name: 'POS Fact. Panam\u00e1',
                    to: '/servicios/facturacion-panama',
                    active: true
                }
                ,
                {
                    name: 'POS Fact. Per\u00fa',
                    to: '/servicios/facturacion-peru',
                    active: true
                }
                ,
                {
                    name: 'POS Fact. Bolivia',
                    to: '/servicios/facturacion-bolivia',
                    active: true
                }
                ,
                {
                    name: 'POS Fact. El Salvador',
                    to: '/servicios/facturacion-elsalvador',
                    active: true
                }
                ,
                {
                    name: 'POS Fact. Costa Rica',
                    to: '/servicios/facturacion-costarica',
                    active: true
                }
                ,
                {
                    name: 'POS Fact. M\u00e9xico',
                    to: 'http://facturacion.pade.mx/',
                    active: true
                }
            ]
        }
    ]
};




export const pagesRoutes = {
    label: 'M\u00f3dulos',
    children: [
        {
            name: 'POS Registro TAECEL',
            to: '/servicios/registro-taecel',
            active: true
        },
        {
            name: 'POS NIF Adicional',
            to: '/servicios/nif-adicional',
            active: true
        }

    ]
};


export default [
    dashboardRoutes,
    appRoutes,
    pagesRoutes
];
